<template>
  <ul class="list--game-media reset flex flex-align-center flex-wrap">
    <li v-if="game.media && game.media.tickets">
      <a
        :href="game.media.tickets"
        target="_blank"
        class="sidearm-mm-btn --ghost mr-1"
        >Tickets</a
      >
    </li>
    <li v-if="game.media && game.media.program">
      <a
        :href="game.media.program"
        target="_blank"
        class="sidearm-mm-btn --ghost mr-1"
        >{{ game.media.program_text || "Program" }}</a
      >
    </li>
    <li v-if="game.media && game.media.tv">
      <span target="_blank" class="sidearm-mm-btn --ghost mr-1">{{
        game.media.tv
      }}</span>
    </li>
    <li v-if="game.media && game.media.video">
      <a
        :href="game.media.video"
        target="_blank"
        class="sidearm-mm-btn --ghost mr-1"
        >{{ game.media.video_text || "Watch" }}</a
      >
    </li>
    <li v-if="game.media && game.media.audio">
      <a
        :href="game.media.audio"
        target="_blank"
        class="sidearm-mm-btn --ghost mr-1"
        >{{ game.media.audio_text || "Listen" }}</a
      >
    </li>
    <li v-if="game.media && game.media.radio">
      <a
        :href="game.media.radio"
        target="_blank"
        class="sidearm-mm-btn --ghost mr-1"
        >Radio</a
      >
    </li>
    <li v-if="game.media && game.media.stats">
      <a
        :href="game.media.stats"
        target="_blank"
        class="sidearm-mm-btn --ghost mr-1"
        >Livestats</a
      >
    </li>
    <li v-for="(gamefile, index) in game_media_gamefiles" :key="index">
      <a
        :href="gamefile.url"
        target="_blank"
        class="sidearm-mm-btn --ghost mr-1"
        >{{ gamefile.title }}</a
      >
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    game: { type: [Object, null], required: true }
  },

  computed: {
    game_media_gamefiles() {
      if (this.game && this.game.media && this.game.media.gamefiles) {
        return this.game.media.gamefiles.filter(x => x.title && x.url);
      }
      return [];
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
ul.list--game-media{
  padding:1em;
}
ul.list--game-media li{
  padding: .5em 0;
}
</style>
